import React from 'react';
import { Link } from 'react-router-dom';

export interface WorkItemProps {
  image: string;
  alt: string;
  text: string;
  link?: string;
}

const WorkItem: React.FC<WorkItemProps> = ({ image, alt, text, link }) => {
  const content = (
    <>
      <img src={image} alt={alt} />
      <div className="work-text">{text}</div>
    </>
  );

  if (link) {
    return (
      <Link to={link} className="work-item-link fadeUp">
        <div className="work-item">
          {content}
        </div>
      </Link>
    );
  }

  return (
    <div className="work-item">
      {content}
    </div>
  );
};

export default WorkItem;
